export const SET_DUPLICATE_INCIDENTS_ITEMS = 'SET_DUPLICATE_INCIDENTS_ITEMS';
export const SET_DUPLICATE_INCIDENTS_LOG_ITEMS = 'SET_DUPLICATE_INCIDENTS_LOG_ITEMS';
export const SET_DUPLICATE_INCIDENTS_FILTERS = 'SET_DUPLICATE_INCIDENTS_FILTERS';
export const SET_DUPLICATE_INCIDENT_DATA = 'SET_DUPLICATE_INCIDENT_DATA';
export const SET_ORIGINAL_INCIDENT_DATA = 'SET_ORIGINAL_INCIDENT_DATA';

export default {
  /**
   * Save duplicate incidents data.
   *
   * @param {Object} state - Duplicate incidents state.
   * @param {{ items: Array, totalItems: number }} data - Duplicate incidents data to set
   */
  [SET_DUPLICATE_INCIDENTS_ITEMS]: (state, { items }) => {
    state.items = items;
  },

  /**
   * Save duplicate incidents log data.
   *
   * @param {Object} state - Duplicate incidents state.
   * @param {{ items: Array, totalItems: number }} data - Duplicate incidents log data to set
   */
  [SET_DUPLICATE_INCIDENTS_LOG_ITEMS]: (state, { items }) => {
    state.logItems = items;
  },

  /**
   * Saves filters of duplicate incidents.
   *
   * @param {Object} state - Duplicate incidents state.
   * @param {Object} filters - Filters to set.
   */
  [SET_DUPLICATE_INCIDENTS_FILTERS]: (state, filters) => {
    state.filters = filters;
  },

  /**
   * Set duplicate incident data.
   *
   * @param {Object} state - Duplicate incidents state.
   * @param {Object} data - Data to set.
   */
  [SET_DUPLICATE_INCIDENT_DATA]: (state, data) => {
    state.duplicateIncidentData = data;
  },

  /**
   * Set original incident data.
   *
   * @param {Object} state - Duplicate incidents state.
   * @param {Object} data - Data to set.
   */
  [SET_ORIGINAL_INCIDENT_DATA]: (state, data) => {
    state.originalIncidentData = data;
  },
};
